export const BRAND = {
  nom: "Lycée professionnel privé Joseph Wresinski",
  nomCourt: "Lycée Joseph Wresinski",
  ville: "Angers",
  adresse: "10 rue Valentin Haüy, 49100 Angers",
  telephone: "02 52 09 41 01",
  email: "contact@lpjw.fr",
  siteWeb: "www.lyceejosephwresinski.fr",
  horaires: "Du lundi au vendredi : 8h00 – 12h30 / 13h15 – 17h30",
  codeUAI: "0492432C",
  siret: "786 117 317 00051",
  baseline: "Un lycée pour apprendre un métier et construire son avenir",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/1485923a-34cf-473c-acab-2da74ca2c2d9/images/4a96a9dfbef2c4d91f2fb405de6d7c50e0c26b2b0c58dc86fec467630026c385.png",
  values: "https://static.prod-images.emergentagent.com/jobs/1485923a-34cf-473c-acab-2da74ca2c2d9/images/8f3378f7957ba630a8be3e924e5b6c733aacd154d92bbd5f29fb395313e5ee83.png",
  abstract: "https://static.prod-images.emergentagent.com/jobs/1485923a-34cf-473c-acab-2da74ca2c2d9/images/7ec784d3fb79375135ac7824df811c1a750eaf5c2757df2f8592fa2ce644d2ef.png",
  workshop: "https://images.pexels.com/photos/5265284/pexels-photo-5265284.jpeg",
  classroom: "https://images.unsplash.com/photo-1635625203639-b793c70ba6c9?auto=format&fit=crop&w=1400&q=80",
  campus: "https://images.unsplash.com/photo-1621192754911-ffe0d95929dd?auto=format&fit=crop&w=1400&q=80",
  internat: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  partenaires: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80",
};

// Navigation principale (affichée en haut sur desktop)
export const MAIN_NAV = [
  { label: "Accueil", to: "/" },
  { label: "Le Lycée", to: "/le-lycee" },
  { label: "Formations", to: "/formations" },
  { label: "Vie au lycée", to: "/vie-au-lycee" },
  { label: "Parents / Élèves", to: "/parents-eleves" },
  { label: "Actualités", to: "/actualites" },
];

// Menu déroulant "Découvrir +" (desktop) + visible dans le menu mobile
export const SECONDARY_NAV = [
  { label: "Dispositifs & options", to: "/dispositifs" },
  { label: "3ème Prépa-Métiers", to: "/prepa-metiers" },
  { label: "Alternance (UFA)", to: "/alternance" },
  { label: "Accompagnement & orientation", to: "/orientation" },
  { label: "Erasmus+", to: "/erasmus" },
  { label: "Inclusion (ULIS · UPE2A)", to: "/inclusion" },
  { label: "Internat", to: "/internat" },
  { label: "Espace entreprises", to: "/entreprises" },
  { label: "Infos pratiques & tarifs", to: "/infos-pratiques" },
  { label: "Espace téléchargement", to: "/telechargements" },
];

// Liste complète (utilisée par le footer et le menu mobile)
export const NAV = [
  ...MAIN_NAV,
  ...SECONDARY_NAV,
  { label: "Contact", to: "/contact" },
];
